import { z, ZodTypeAny } from 'zod'

// @TODO: Implement analysis type
export const analysis = (z.any() as ZodTypeAny).optional()
